'use client';

import Link from 'next/link';
import { motion } from 'motion/react';
import { finalCtaButtonLabel, finalCtaHeadlineSubtext } from '@/lib/invite-only';

export function FinalCta() {
  return (
    <section
      id="final-cta"
      className="relative scroll-mt-20 overflow-hidden border-t border-[var(--landing-border)] py-28 px-4"
      aria-labelledby="final-cta-heading"
    >
      {/* Aurora / gradient background */}
      <div
        className="absolute inset-0 opacity-40"
        aria-hidden
        style={{
          background:
            'radial-gradient(ellipse 80% 60% at 50% 50%, var(--landing-accent-blue) 0%, transparent 50%), radial-gradient(ellipse 60% 40% at 70% 30%, var(--landing-accent-red) 0%, transparent 45%)',
        }}
      />
      <div className="absolute inset-0 bg-[var(--landing-bg)]/80" aria-hidden />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="relative z-10 mx-auto max-w-2xl text-center"
      >
        <h2
          id="final-cta-heading"
          className="font-heading text-3xl font-bold text-white md:text-4xl lg:text-5xl"
        >
          Elevate Your Next Shoot
        </h2>
        <p className="mt-4 text-lg text-white/90 md:text-xl">{finalCtaHeadlineSubtext()}</p>
        <Link
          href="/signup"
          className="mt-8 inline-block rounded-xl bg-[var(--landing-accent-red)] px-10 py-4 font-heading text-lg font-semibold text-white shadow-[0_0_40px_-8px_rgba(255,77,77,0.5)] transition hover:opacity-95 focus:outline-none focus:ring-2 focus:ring-[var(--landing-accent-red)] focus:ring-offset-2 focus:ring-offset-black"
        >
          {finalCtaButtonLabel()}
        </Link>
        <p className="mt-6 text-sm text-white/70">
          <Link
            href="/login"
            className="text-[var(--landing-accent-blue)] underline-offset-4 hover:underline focus:outline-none focus:ring-2 focus:ring-[var(--landing-accent-blue)] focus:ring-offset-2 focus:ring-offset-black"
          >
            Sign in
          </Link>{' '}
          if you already have an account.
        </p>
      </motion.div>
    </section>
  );
}
